import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { LoginService } from 'src/app/auth/services/logIn.service';
import { LanguageService } from 'src/app/languages/services/language.service';

import { UserService } from '../../services/user.service';

import { CommonResponse } from 'src/app/shared/models/reponse.model';
import { PageLoadingService } from 'src/app/shared/services/page-loading.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent {

  userForm: FormGroup;
  changePasswordUser: FormGroup;

  accountName!: string;
  userId!: number;

  toggleForms = false;
  isCountryAdmin = false;

  userCountries: any[] = [];
  languages: any[] = [];

  @ViewChild('passwordInput') passwordInput!: ElementRef;
  @ViewChild('passwordConfirmInput') passwordConfirmInput!: ElementRef;

  private readonly getAllUsersObserver = {
    next: (data: CommonResponse<any>) => this.getAllInfoUsersNext(data),
    error: (error: CommonResponse<any>) => this.getAllInfoUsersError(error)
  };

  constructor(
    public dialogRef: MatDialogRef<MyAccountComponent>,
    private _formBuilder: FormBuilder,
    private _loginService: LoginService,
    private _userService: UserService,
    private _pageLoadingService: PageLoadingService,
    private _snackbarService: SnackbarService,
    private _translateService: TranslateService,
    private _languageService: LanguageService
  ) {

    this.userForm = this._formBuilder.group({
      userName: new FormControl(''),
      email: new FormControl(''),
      adress: new FormControl(''),
      phoneIndicative: new FormControl(''),
      phoneNumber: new FormControl(''),
      defaultLanguageCode: new FormControl('')
    });

    this.changePasswordUser = this._formBuilder.group({
      newPassWord: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    });

    const user = this._loginService.getLoggedUser();

    if (user) {

      this.accountName = user.email;
      this.userId = user.userId;

      this._userService
        .getUserInfo(user.userId)
        .subscribe(this.getAllUsersObserver);

      const userData = JSON.parse(
        sessionStorage.getItem('logged_user') || '{}'
      );

      const userLanguage = userData?.language?.languageCode;

      console.log('userLanguage -->', userLanguage);

      this._languageService.getAllLanguages().subscribe({
        next: (data: CommonResponse<any>) => {

          this.languages = data.data ?? [];

          this.userForm.patchValue({
            defaultLanguageCode: userLanguage
          });

          console.log('formValue -->', this.userForm.value);
        }
      });
    }
  }

  togglePasswordVisibility(): void {
    const inputPassword =
      this.passwordInput.nativeElement as HTMLInputElement;

    inputPassword.type =
      inputPassword.type === 'password'
        ? 'text'
        : 'password';

    const inputPasswordConfirm =
      this.passwordConfirmInput.nativeElement as HTMLInputElement;

    inputPasswordConfirm.type =
      inputPasswordConfirm.type === 'password'
        ? 'text'
        : 'password';
  }

  toggleFomrsFunction(): void {
    this.toggleForms = true;
  }

  back(): void {
    this.toggleForms = false;
  }

  close(): void {
    this.dialogRef.close(true);
  }

  generateFormDataRequest(): FormData {
    const requestFormData = new FormData();

    requestFormData.set(
      'userName',
      this.userForm.get('userName')?.value ?? ''
    );

    requestFormData.set(
      'email',
      this.userForm.get('email')?.value ?? ''
    );

    requestFormData.set(
      'adress',
      this.userForm.get('adress')?.value ?? ''
    );

    requestFormData.set(
      'phoneIndicative',
      this.userForm.get('phoneIndicative')?.value ?? ''
    );

    requestFormData.set(
      'phoneNumber',
      this.userForm.get('phoneNumber')?.value ?? ''
    );

    requestFormData.set(
      'defaultLanguageCode',
      this.userForm.get('defaultLanguageCode')?.value ?? ''
    );

    return requestFormData;
  }

  getAllInfoUsersNext(data: CommonResponse<any>): void {
    const infoUserData = data.data;

    if (!infoUserData) {
      return;
    }

    this.userForm.patchValue({
      userName: infoUserData.name ?? '',
      email: infoUserData.email ?? '',
      adress: infoUserData.address ?? '',
      phoneIndicative: infoUserData.numberIndicator ?? '',
      phoneNumber: infoUserData.phone ?? '',
      defaultLanguageCode:
        infoUserData.defaultLanguageCode ?? ''
    });

    const userRoles = infoUserData.rol ?? [];

    if (
      userRoles.some(
        (role: { roleId: number }) =>
          role.roleId === 4
      )
    ) {
      this.isCountryAdmin = true;
      this.userCountries =
        infoUserData.countries ?? [];
    }
  }

  getAllInfoUsersError(
    error: CommonResponse<any>
  ): void {

    this._pageLoadingService.hideLoadingGif();

    if (error.statusCode === 404) {
      this._snackbarService.openStandardSnackBar(
        'getAllUsersError404'
      );
      return;
    }

    this._snackbarService.openStandardSnackBar(
      'getAllUsersError'
    );
  }

  onSubmit(): void {
    this._userService
      .updateUserInfo(
        this.generateFormDataRequest(),
        this.userId
      )
      .subscribe(() => {

        const selectedLanguage =
          this.userForm.get('defaultLanguageCode')?.value;

        if (selectedLanguage) {

          const localeMap: Record<string, string> = {
            spa: 'es',
            eng: 'en',
            por: 'pt'
          };

          const locale =
            localeMap[selectedLanguage] ?? 'es';

          // Actualizar logged_user
          const userData = JSON.parse(
            sessionStorage.getItem('logged_user') || '{}'
          );

          if (userData.language) {
            userData.language.languageCode = selectedLanguage;
          }

          sessionStorage.setItem(
            'logged_user',
            JSON.stringify(userData)
          );

          // Cambiar idioma de la aplicación
          sessionStorage.setItem('siteLanguage', locale);

          this._translateService.use(locale);
          this._translateService.currentLang = locale;
        }

        this._pageLoadingService.hideLoadingGif();

        this._snackbarService.openStandardSnackBar(
          'succesUpdateUSer',
          'Ok'
        );
      });
  }
  
  getCountryNameByLanguage(
    countries: string[]
  ): string[] {

    const lang =
      this._translateService.currentLang as
      'es' | 'en' | 'pt';

    const countryMappings: Record<
      'es' | 'en' | 'pt',
      string[]
    > = {
      es: ['Colombia', 'España'],
      en: ['Colombia', 'Spain'],
      pt: ['Colômbia', 'Espanha']
    };

    return Array.from(
      new Set(
        countries.filter(country =>
          countryMappings[lang]?.includes(country)
        )
      )
    );
  }

  comparePasswords():
    | FormData
    | false {

    const requestFormPasswordData =
      new FormData();

    const password =
      this.changePasswordUser.get(
        'newPassWord'
      )?.value;

    const confirmPassword =
      this.changePasswordUser.get(
        'confirmPassword'
      )?.value;

    if (password !== confirmPassword) {
      this._snackbarService.openStandardSnackBar(
        'confirm_passwords'
      );

      return false;
    }

    requestFormPasswordData.set(
      'newPassWord',
      password
    );

    return requestFormPasswordData;
  }

  onSubmitPassword(): void {
    const formData =
      this.comparePasswords();

    if (!formData) {
      return;
    }

    this._userService
      .updateUserPassword(
        formData,
        this.userId
      )
      .subscribe(() => {

        this._pageLoadingService.hideLoadingGif();

        this._snackbarService.openStandardSnackBar(
          'password_succes',
          'ok'
        );
      });
  }
}